module.exports = __webpack_public_path__ + "static/media/wave.518f308d.png";